export const Blue = "#3643BA";
export const Black = "#101010";
export const Quiet = "#E1E3F5";
export const White = "#FFF";
export const Background = "#f7f8f9";
export const Grey = "#616161";
export const Neutral = "#949494";
export const BorderQuiet = "#E1E0DF";
export const TextQuiet = "#616161";
export const Green = "#7AFFA6";
export const GreyWhite = "#F5F4F5";
export const Yellow = "#DBC26C";
export const Red = "#D32F2F";
